class Note {
    public NoteId: string;
    public ContactId: string;
    public NoteContent: string;
    public NoteDate: Date;
    public type: string;
}

export { Note };
